// extracted by mini-css-extract-plugin
export default {"wrapper":"List_wrapper__fSn2-","messages":"List_messages__ftdJq","scrollButton":"List_scrollButton__bJkl+","spinnerWrapper":"List_spinnerWrapper__OkEoK"};